module.exports = __webpack_public_path__ + "img/banner-img02-2.e3cbbc37.jpg";